import { render, staticRenderFns } from "./PurchaseOrder.vue?vue&type=template&id=55311515&scoped=true&"
import script from "./PurchaseOrder.vue?vue&type=script&lang=js&"
export * from "./PurchaseOrder.vue?vue&type=script&lang=js&"
import style0 from "./PurchaseOrder.vue?vue&type=style&index=0&id=55311515&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55311515",
  null
  
)

export default component.exports